import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type {
  GetVirtualTourInfosParams,
  GetVirtualTourInfosResponse,
} from '@/app-package';

/**
 * Retrieves virtual tour information for a specific listing
 * @param listingId - The ID of the listing to get virtual tour info for
 */
const getVirtualTourInfos = async ({
  listingId,
}: GetVirtualTourInfosParams) => {
  const config: AxiosRequestConfig = {
    url: `/virtual_tour/config/${listingId}/`,
    method: 'get',
  };

  const { data } = await axios.request<GetVirtualTourInfosResponse>(config);

  return data;
};

export default getVirtualTourInfos;
